import { Model } from "@/models/base/model";

export class UserDisease extends Model {
  constructor(params: any = {}) {
    super(params);
  }

  // ユーザー病気一覧取得
  async getUserDisease(): Promise<any> {
    this.url = "/cms/api/users/diseases/list";
    return super.fetch();
  }
}
